import { FieldValues, useController, UseControllerProps } from 'react-hook-form';

import { PasswordTextInput } from '../PasswordTextInput/PasswordTextInput';
import { IPasswordTextInputProps } from '../PasswordTextInput/types';

export const PasswordTextInputControlled = <T extends FieldValues>(
  props: UseControllerProps<T> & IPasswordTextInputProps
) => {
  const { name, control, rules, defaultValue, ...restProps } = props;

  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  const { ref, value, ...restField } = field;
  const { error } = fieldState;

  return <PasswordTextInput inputRef={ref} value={value ?? ''} fieldError={error} {...restField} {...restProps} />;
};
